export const generateRandomKey = () => {
  // Note: emotion disallows non-letters (except for `-`) in its key
  const letters = 'abcdefghijklmnopqrstuvwxyz';

  let randomString = '';
  for (let i = 0; i < 8; i += 1) {
    randomString += letters[Math.floor(Math.random() * letters.length)];
  }

  return randomString;
};
